import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h2 className="footer__title">C.</h2>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>
          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>
          <li>
            <a href="#services" className="footer__link">
              Services
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://github.com/CarolinaBrazalesSempere"
            className="footer__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i class="uil uil-github-alt"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/carolinabrazales-software-developer/"
            className="footer__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i class="uil uil-linkedin"></i>
          </a>
          <a
            href="mailto:carolbrazalessempere@gmail.com"
            className="footer__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i class="uil uil-envelope-alt"></i>
          </a>
        </div>

        <span className="footer__copy">
          &#169; Nearly all rights reserved, Carolina B. Sempere, 2024 made with
          ⚛️ and 💛
        </span>
      </div>
    </footer>
  );
};

export default Footer;
